import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DM_PROFILE_RESPONSIVENESS_SCORE_CONFIG = createFcmDetails(
	'dm_profile_responsiveness_score_config',
	{
		owner: 'Capybara Squad',
		context: 'Decision maker profile page responsiveness score',
		import: false,
		description:
			'Holds a config for the labels and color codes for the DM responsiveness score, as well as contact details.',
		template: {
			contact: {
				email: 'decisionmaker@change.org',
				phone: '+11 223 445 678',
			},
			tags: [
				{
					min: 0,
					max: 50,
					label: 'Responsive',
					color: '#eeaabb',
					labelColor: '#eeaabb',
					textColor: '#ffffff',
				},
				{
					min: 51,
					max: 100,
					label: 'Moderately responsive',
					color: '#eeaabb',
					labelColor: '#eeaabb',
					textColor: '#ffffff',
				},
			],
		},
	},
);
